import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { required } from "@vuelidate/validators";
import { APPLICATION_STEPS, FILL_OUT_PAGES, FILL_OUT_SECTIONS } from "@Client/@Utils/enums";
import { differenceBy, flattenDeep, get, isEmpty, isNumber, kebabCase, reduce, some } from "lodash";
import { splitPath } from "./application-standalone-helpers";
import { APPLICATION_VISIBILITY_TOGGLES } from "@Client/@Utils/application/visibility-toggles";
import { useApplicationPathIndexesV2 } from "@Shared/@Composables/application/useApplicationPathIndexes";
export const GET_FIELD_BY_PATH = "GET_FIELD_BY_PATH";
export const GET_SCHEMA_RULES_BY_PATH = "GET_SCHEMA_RULES_BY_PATH";
export const GET_CURRENT_APPLICATION = "GET_CURRENT_APPLICATION";
export const GET_CURRENT_SCHEMA = "GET_CURRENT_SCHEMA";
export const GET_CURRENT_COMPUTED_SCHEMA = "GET_CURRENT_COMPUTED_SCHEMA";
export const GET_CURRENT_FLOW = "GET_CURRENT_FLOW";
export const GET_DISCLAIMERS = "GET_DISCLAIMERS";
export const GET_ACCEPTED_CONSENTS = "GET_ACCEPTED_CONSENTS";
export const GET_APPLICATION_STATUS = "GET_APPLICATION_STATUS";
export const IS_FILL_OUT = "IS_FILL_OUT";
export const CONSOLIDATED_REQUEST_FILL_OUT = "CONSOLIDATED_REQUEST_FILL_OUT";
export const PAGES_TO_FILL_OUT = "PAGES_TO_FILL_OUT";
export const GUEST_FILL_OUT_CLIENT_DETAILS = "GUEST_FILL_OUT_CLIENT_DETAILS";
export const SESSION_TOKEN = "SESSION_TOKEN";
export const MORTGAGE_DETAILS_REQUESTED = "MORTGAGE_DETAILS_REQUESTED";
export const PROPERTY_REQUESTED = "PROPERTY_REQUESTED";
export const HAS_CONSOLIDATED_REQUEST = "HAS_CONSOLIDATED_REQUEST";
export const LOADING = "LOADING";
export const CONSOLIDATED_REQUEST_CLIENT_USERNAME = "CONSOLIDATED_REQUEST_CLIENT_USERNAME";
export const GET_ADDITIONAL_INFORMATION = "GET_ADDITIONAL_INFORMATION";
export const APPLICATION_IS_LOCKED = "APPLICATION_IS_LOCKED";
export const APPLICANTS_WITHOUT_REQUEST = "APPLICANTS_WITHOUT_REQUEST";
export const CO_APPLICANTS_LENGTH = "CO_APPLICANTS_LENGTH";
export const TOTAL_APPLICATIONS = "TOTAL_APPLICATIONS";
export const APPLICATION_HAS_REQUESTED_DOCUMENTS = "APPLICATION_HAS_REQUESTED_DOCUMENTS";
export const GET_COAPPLICANT_STATUS = "GET_COAPPLICANT_STATUS";
const getters = {
  [GET_CURRENT_APPLICATION]: state => {
    const {
      currentApplicationId,
      applications
    } = state;
    if (currentApplicationId) {
      return applications.byId[currentApplicationId];
    } else {
      return {};
    }
  },
  [GET_CURRENT_COMPUTED_SCHEMA]: state => {
    const {
      currentComputedSchema
    } = state;
    return currentComputedSchema;
  },
  [GET_CURRENT_SCHEMA]: state => {
    const {
      currentApplicationId,
      schema
    } = state;
    if (!currentApplicationId) return {};
    return schema.byId[currentApplicationId];
  },
  [GET_CURRENT_FLOW]: state => {
    var _applications$byId$cu, _applications$byId$cu2;
    const {
      currentApplicationId,
      applications
    } = state;
    if (!currentApplicationId) return "";
    return (_applications$byId$cu = (_applications$byId$cu2 = applications.byId[currentApplicationId]) == null ? void 0 : _applications$byId$cu2.flow) != null ? _applications$byId$cu : "";
  },
  [GET_FIELD_BY_PATH]: (state, getters) => path => {
    const currentApplication = getters["GET_CURRENT_APPLICATION"];
    return get(currentApplication, path);
  },
  [GET_SCHEMA_RULES_BY_PATH]: (state, getters) => (path, moreRules = {}, indexes = {}) => {
    var _APPLICATION_VISIBILI;
    const {
      flow
    } = state;
    const currentApplicationSchema = getters.GET_CURRENT_SCHEMA;
    const {
      parentPath
    } = splitPath(path);
    if (isEmpty(currentApplicationSchema)) return {};
    const requiredFromSchema = get(currentApplicationSchema, path).required[flow];
    const visible = get(currentApplicationSchema, path).visible[flow];
    const {
      isVisibleWhen
    } = (_APPLICATION_VISIBILI = APPLICATION_VISIBILITY_TOGGLES[path]) != null ? _APPLICATION_VISIBILI : {};
    const isVisibleFromToggle = isVisibleWhen ? some(isVisibleWhen, ({
      hasValues,
      lessThan,
      moreThan
    }, dependencyPath) => {
      if (_includesInstanceProperty(path).call(path, "co-applicants") && indexes["co-applicants"] > 0) {
        indexes["co-applicants"]--;
      }
      const {
        pathWithIndexes
      } = useApplicationPathIndexesV2(dependencyPath, indexes);
      const dependencyValue = getters.GET_FIELD_BY_PATH(pathWithIndexes);
      const hasValuesCheck = hasValues == null ? void 0 : hasValues.some(value => dependencyValue === value);
      const moreThanCheck = isNumber(moreThan) && dependencyValue > moreThan;
      const lessThanCheck = isNumber(lessThan) && dependencyValue < moreThan;
      return hasValuesCheck || moreThanCheck || lessThanCheck;
    }) : true;
    if (visible && isVisibleFromToggle) {
      let rules = {};
      if (requiredFromSchema) rules.required = required;
      rules = reduce(moreRules, (acc, rule, ruleName) => {
        if (ruleName === "requiredSin" && !requiredFromSchema) return acc;
        acc[ruleName] = typeof rule === "function" ? rule({
          isRequired: requiredFromSchema,
          getVisibilityByPath: innerPath => get(currentApplicationSchema, innerPath).visible[flow],
          getFieldByPath: getters.GET_FIELD_BY_PATH,
          getCurrentFlow: () => getters.GET_CURRENT_FLOW,
          getParentVisibility: () => get(currentApplicationSchema, parentPath).visible[flow],
          getSiblingVisibility: sibling => get(currentApplicationSchema, parentPath + `[${kebabCase(sibling)}]`).visible[flow],
          getSiblingValue: sibling => getters.GET_FIELD_BY_PATH(parentPath + `[${kebabCase(sibling)}]`)
        }) : rule;
        return acc;
      }, rules);
      return rules;
    }
    return {};
  },
  [GET_DISCLAIMERS]: state => {
    var _state$disclaimers;
    return (_state$disclaimers = state.disclaimers) != null ? _state$disclaimers : [];
  },
  [GET_ACCEPTED_CONSENTS]: state => {
    var _state$acceptedConsen;
    return (_state$acceptedConsen = state.acceptedConsents) != null ? _state$acceptedConsen : [];
  },
  [GET_APPLICATION_STATUS]: state => {
    var _state$applicationsMe, _state$applicationsMe2;
    const {
      currentApplicationId: applicationId
    } = state;
    if (!applicationId) return "";
    return (_state$applicationsMe = (_state$applicationsMe2 = state.applicationsMetadata.byId[applicationId]) == null ? void 0 : _state$applicationsMe2.applicationStatus) != null ? _state$applicationsMe : "";
  },
  [GET_COAPPLICANT_STATUS]: state => {
    var _state$guestFillOutDe, _state$guestFillOutDe2, _state$consolidatedRe, _state$consolidatedRe2, _coApplicants$find$st, _coApplicants$find;
    const coApplicantId = (_state$guestFillOutDe = state.guestFillOutDetails) == null ? void 0 : (_state$guestFillOutDe2 = _state$guestFillOutDe.clientDetails) == null ? void 0 : _state$guestFillOutDe2.coApplicantId;
    const coApplicants = (_state$consolidatedRe = state.consolidatedRequest) == null ? void 0 : (_state$consolidatedRe2 = _state$consolidatedRe.metadata) == null ? void 0 : _state$consolidatedRe2.coApplicants;
    return coApplicants && coApplicants.length > 0 ? (_coApplicants$find$st = (_coApplicants$find = _findInstanceProperty(coApplicants).call(coApplicants, coApp => coApp.id === coApplicantId)) == null ? void 0 : _coApplicants$find.status) != null ? _coApplicants$find$st : "" : "";
  },
  [IS_FILL_OUT]: state => {
    return state.isFillOut;
  },
  [CONSOLIDATED_REQUEST_FILL_OUT]: (state, getters) => {
    var _state$consolidatedRe3;
    if (!getters[IS_FILL_OUT]) return ((_state$consolidatedRe3 = state.consolidatedRequest.metadata) == null ? void 0 : _state$consolidatedRe3.fillOut) || [];
    const {
      coApplicantId
    } = getters[GUEST_FILL_OUT_CLIENT_DETAILS];
    if (!coApplicantId) return [];
    const {
      coApplicants
    } = state.consolidatedRequest.metadata || {};
    const applicantRequest = coApplicants == null ? void 0 : _findInstanceProperty(coApplicants).call(coApplicants, ({
      id
    }) => id === coApplicantId);
    return (applicantRequest == null ? void 0 : applicantRequest.fillOut) || [];
  },
  [PAGES_TO_FILL_OUT]: (state, getters) => {
    var _context;
    const fillOutSections = !getters[HAS_CONSOLIDATED_REQUEST] ? flattenDeep(_Object$values(FILL_OUT_PAGES)) : _reduceInstanceProperty(_context = getters[CONSOLIDATED_REQUEST_FILL_OUT]).call(_context, (sections, {
      key
    }) => {
      const pages = FILL_OUT_PAGES[key];
      if (pages) {
        sections.push(...pages);
      }
      return sections;
    }, []);
    if (!(getters[IS_FILL_OUT] || _includesInstanceProperty(fillOutSections).call(fillOutSections, APPLICATION_STEPS.GOALS))) fillOutSections.unshift(APPLICATION_STEPS.GOALS);
    fillOutSections.push(APPLICATION_STEPS.SUBMIT);
    return fillOutSections;
  },
  [GUEST_FILL_OUT_CLIENT_DETAILS]: state => {
    const {
      clientDetails: {
        coApplicantId
      }
    } = state.guestFillOutDetails;
    return _objectSpread(_objectSpread({}, state.guestFillOutDetails.clientDetails), {}, {
      username: coApplicantId
    });
  },
  [SESSION_TOKEN]: state => {
    return state.guestFillOutDetails.token;
  },
  [MORTGAGE_DETAILS_REQUESTED]: (state, getters) => {
    return getters[CONSOLIDATED_REQUEST_FILL_OUT].some(({
      key
    }) => key === FILL_OUT_SECTIONS.MORTGAGE_DETAILS);
  },
  [PROPERTY_REQUESTED]: (state, getters) => {
    return getters[CONSOLIDATED_REQUEST_FILL_OUT].some(({
      key
    }) => key === FILL_OUT_SECTIONS.PROPERTY);
  },
  [HAS_CONSOLIDATED_REQUEST]: state => {
    var _state$consolidatedRe4, _state$consolidatedRe5;
    return !isEmpty(state.consolidatedRequest) && !isEmpty((_state$consolidatedRe4 = state.consolidatedRequest) == null ? void 0 : (_state$consolidatedRe5 = _state$consolidatedRe4.metadata) == null ? void 0 : _state$consolidatedRe5.fillOut);
  },
  [LOADING]: state => {
    return state.loading;
  },
  [CONSOLIDATED_REQUEST_CLIENT_USERNAME]: state => {
    const {
      clientUsernameToUse = ""
    } = state.consolidatedRequest.metadata || {};
    return clientUsernameToUse;
  },
  [GET_ADDITIONAL_INFORMATION]: state => {
    return state.additionalInformation;
  },
  [APPLICATION_IS_LOCKED]: state => {
    var _state$applicationsMe3;
    const {
      currentApplicationId: applicationId
    } = state;
    return !!(applicationId && (_state$applicationsMe3 = state.applicationsMetadata.byId[applicationId]) != null && _state$applicationsMe3.locked);
  },
  [APPLICANTS_WITHOUT_REQUEST]: (state, getters) => {
    var _applicantsWithoutReq;
    const {
      coApplicants
    } = state.consolidatedRequest.metadata || {};
    const {
      "co-applicants": coApplicantsFromApplication
    } = getters[GET_CURRENT_APPLICATION];
    const applicantsWithoutRequest = differenceBy(coApplicantsFromApplication, coApplicants, "id");
    return (_applicantsWithoutReq = applicantsWithoutRequest == null ? void 0 : _mapInstanceProperty(applicantsWithoutRequest).call(applicantsWithoutRequest, ({
      id
    }) => id)) != null ? _applicantsWithoutReq : [];
  },
  [CO_APPLICANTS_LENGTH]: (state, getters) => {
    var _currentApplication$c, _currentApplication$c2;
    const currentApplication = getters[GET_CURRENT_APPLICATION];
    return (_currentApplication$c = currentApplication == null ? void 0 : (_currentApplication$c2 = currentApplication["co-applicants"]) == null ? void 0 : _currentApplication$c2.length) != null ? _currentApplication$c : 0;
  },
  [TOTAL_APPLICATIONS]: state => {
    return state.applications.allIds.length;
  },
  [APPLICATION_HAS_REQUESTED_DOCUMENTS]: state => {
    var _state$applicationsMe4;
    const {
      currentApplicationId: applicationId
    } = state;
    return !!(applicationId && (_state$applicationsMe4 = state.applicationsMetadata.byId[applicationId]) != null && _state$applicationsMe4.hasRequestedDocuments);
  }
};
export default getters;